import axios from 'axios';
import { BehaviorSubject } from 'rxjs';

import authService from './authService';

//base urls to be extended upon request
const JOB_URL = process.env.REACT_APP_JOB_APIURL;

//Observables declarations
// export const userData$ = new BehaviorSubject();
export const job$ = new BehaviorSubject(); // not used

/* const config = {
  headers: {
    'Content-Type': 'application/json',
    authorization: authService.setAuthHeader(),
  },
}; */
// getJobById
const getJobById = async (id, userData) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      authorization: userData.token,
    },
  };
  const result = await axios.get(`${JOB_URL}/${id}`, config);
  return result;
};
//getAllJobs
const getAllJobs = async (page, userData) => {
  const configuration = {
    headers: {
      'Content-Type': 'application/json',
      authorization: userData.token,
    },
  };
  const result = await axios.get(`${JOB_URL}?page=${page}`, configuration);
  return result;
};
// createJob
const createJob = async (formData) => {
  const configuration = {
    headers: {
      'Content-Type': 'application/json',
      authorization: authService.setAuthHeader(),
    },
  };
  // console.log(formData);
  // console.log(config);
  const result = await axios.post(
    `${JOB_URL}/create-job-post`,
    formData,
    configuration
  );

  return result;
};

//updateJob
const updateJob = async (id, formData) => {
  // console.log(id);
  // console.log(formData);
  const configuration = {
    headers: {
      'Content-Type': 'application/json',
      authorization: authService.setAuthHeader(),
    },
  };
  const result = await axios.patch(`${JOB_URL}/${id}`, formData, configuration);

  return result;
};

//deleteJob

//searchJob
const searchJob = async (page, query) => {
  const configuration = {
    headers: {
      'Content-Type': 'application/json',
      authorization: authService.setAuthHeader(),
    },
  };
  const result = await axios.get(
    `${JOB_URL}/search?query=${query}&page=${page}`,
    configuration
  );
  return result;
  // console.log(query);
};

const jobService = {
  createJob,
  updateJob,
  getJobById,
  getAllJobs,
  searchJob,
};

export default jobService;
